export default __webpack_public_path__ + "static/media/jackie.93e907c5.jpg";